const SEAT_TYPES = {
    SEATER: 'SEATER',
    EXECUTIVE: 'EXECUTIVE',
    SEMI_SLEEPER: 'SEMI_SLEEPER',
    FULL_SLEEPER: 'FULL_SLEEPER',
    SLEEPER_BED: 'SLEEPER_BED',
};
const SEAT_TYPES_PRICING_ORDER = [
    SEAT_TYPES.SEATER,
    SEAT_TYPES.EXECUTIVE,
    SEAT_TYPES.SEMI_SLEEPER,
    SEAT_TYPES.FULL_SLEEPER,
    SEAT_TYPES.SLEEPER_BED,
];

const northAmericanRelationsWithBikes = [
    'US-MX',
    'MX-US',
    'CA-CA',
    'US-CA',
    'CA-US',
].reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [curr]: {
        'logged-in-customer': {
            maxTotalAmount: 9,
            hasGroupTripsMessage: true,
            adult: {
                maxAmount: 9,
            },
            us_children_2_15: {
                maxAmount: 9,
            },
            bike_slot: {
                maxAmount: 5,
            },
            wheelchair: {
                maxAmount: 2,
            },
        },
        customer: {
            maxTotalAmount: 9,
            hasGroupTripsMessage: true,
            adult: {
                maxAmount: 9,
            },
            us_children_2_15: {
                maxAmount: 9,
            },
            bike_slot: {
                maxAmount: 5,
            },
            wheelchair: {
                maxAmount: 2,
            },
        },
    } })), {});
const northAmericanCrossBorderRelationsWithoutBikes = ['MX-CA', 'CA-MX'].reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [curr]: {
        'logged-in-customer': {
            maxTotalAmount: 9,
            hasGroupTripsMessage: true,
            adult: {
                maxAmount: 9,
            },
            us_children_2_15: {
                maxAmount: 9,
            },
            wheelchair: {
                maxAmount: 2,
            },
        },
        customer: {
            maxTotalAmount: 9,
            hasGroupTripsMessage: true,
            adult: {
                maxAmount: 9,
            },
            us_children_2_15: {
                maxAmount: 9,
            },
            wheelchair: {
                maxAmount: 2,
            },
        },
    } })), {});
const extendedProductRules = Object.assign(Object.assign({ 'TR-TR': {
        customer: {
            adult: {
                maxAmount: 10,
            },
        },
        'logged-in-customer': {
            adult: {
                maxAmount: 10,
            },
        },
    }, 'BR-BR': {
        customer: {
            adult: {
                maxAmount: 10,
            },
            br_children_0_15: {
                maxAmount: 10,
            },
            br_child_on_lap: {
                maxAmount: 10,
            },
        },
        'logged-in-customer': {
            adult: {
                maxAmount: 10,
            },
            br_children_0_15: {
                maxAmount: 10,
            },
        },
    }, 'US-US': {
        'logged-in-customer': {
            hasGroupTripsMessage: true,
            maxTotalAmount: 9,
            adult: {
                maxAmount: 9,
            },
            us_children_2_15: {
                maxAmount: 9,
            },
            bike_slot: {
                maxAmount: 5,
            },
            wheelchair: {
                maxAmount: 2,
            },
            us_veteran: {
                maxAmount: 9,
            },
        },
        customer: {
            hasGroupTripsMessage: true,
            maxTotalAmount: 9,
            adult: {
                maxAmount: 9,
            },
            us_children_2_15: {
                maxAmount: 9,
            },
            bike_slot: {
                maxAmount: 5,
            },
            wheelchair: {
                maxAmount: 2,
            },
            us_veteran: {
                maxAmount: 9,
            },
        },
    }, 'MX-MX': {
        'logged-in-customer': {
            maxTotalAmount: 8,
            hasGroupTripsMessage: false,
            adult: {
                maxAmount: 8,
            },
            mx_children_0_17: {
                maxAmount: 8,
            },
            student: {
                maxAmount: 8,
            },
            mx_teacher: {
                maxAmount: 2,
            },
            senior: {
                maxAmount: 2,
            },
        },
        customer: {
            maxTotalAmount: 8,
            hasGroupTripsMessage: false,
            adult: {
                maxAmount: 8,
            },
            mx_children_0_17: {
                maxAmount: 8,
            },
            student: {
                maxAmount: 8,
            },
            mx_teacher: {
                maxAmount: 2,
            },
            senior: {
                maxAmount: 2,
            },
        },
        agency: {
            adult: {
                maxAmount: 42,
            },
            mx_children_0_17: {
                maxAmount: 42,
            },
            student: {
                maxAmount: 8,
            },
            mx_teacher: {
                maxAmount: 2,
            },
            senior: {
                maxAmount: 2,
            },
        },
        'agency-ride-debug': {
            adult: {
                maxAmount: 42,
            },
            mx_children_0_17: {
                maxAmount: 42,
            },
            student: {
                maxAmount: 8,
            },
            mx_teacher: {
                maxAmount: 2,
            },
            senior: {
                maxAmount: 2,
            },
        },
    } }, northAmericanRelationsWithBikes), northAmericanCrossBorderRelationsWithoutBikes);

const productTypes = {
    adult: {
        type: 'adult',
        defaultAmount: 1,
        maxAmount: 42,
    },
    children: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    bike_slot: {
        type: 'device',
        defaultAmount: 0,
        maxAmount: 5,
        withoutCapacity: true,
    },
    student: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_0_11: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_0_13: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_12_15: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_14_17: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pensioner: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_0_5: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_6_14: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pupil: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pwd: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_blind_person_guide: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
        requiredProductTypes: [
            'pl_blind_person',
            'pl_blind_dependent',
            'pl_blind_war_victim',
        ],
    },
    pl_blind_dependent: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_blind_war_victim: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_war_invalid_carer: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
        requiredProductTypes: ['pl_war_invalid_dependent'],
    },
    pl_war_invalid_dependent: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_dependent_carer: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
        requiredProductTypes: ['pl_dependent'],
    },
    pl_dependent: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_border_guard: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_customs_officer: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_police_officer: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_military_police: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_child_disabled_carer: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_child_disabled: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_soldier: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_student_disabled: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_combatant: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_blind_person: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_veteran_invalid: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_war_invalid: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_anti_communist_opposition_activist: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_child_0_4: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    pl_child_5_6: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    senior: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_6_17: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    wheelchair: {
        type: 'device',
        defaultAmount: 0,
        maxAmount: 2,
        withoutCapacity: true,
    },
    children_0_12: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_13_14: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_6_11: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    tr_pwd: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    tr_retired_person: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    children_12_17: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ee_children_0_7: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ee_children_0_15_with_disability: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ee_person_with_disability: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ee_person_with_disability_companion: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_pwd_free: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_ewli_free: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_ewli_half: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_ywli_free: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_ywli_half: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_children_0_5_free: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_children_0_5_full: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_children_0_15: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    br_child_on_lap: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
        withoutCapacity: true,
        requiredProductTypes: ['adult'],
        blockSelectionForMissingRequiredProducts: true,
    },
    ua_soldier: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ua_pitwah: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ua_vwd: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ua_children_lf: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ua_children_0_5: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ee_scholar_student: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    ee_elderly: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    cz_disability_level_3: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    us_children_2_15: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    us_veteran: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    mx_teacher: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    mx_children_0_17: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    se_children_0_15: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    se_young_16_25: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    cl_children_0_13: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    cl_children_14_17: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    sct_nec_5_15: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    sct_nec_16_21: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    sct_nec_60_disabled: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    in_children_0_17: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    lv_person_with_disability_and_carer: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    lv_child_0_7: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    lv_child_8_14: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    lv_orphaned_child: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
    lv_politically_repressed_person: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    lv_large_family_adult: {
        type: 'adult',
        defaultAmount: 0,
        maxAmount: 42,
    },
    lv_large_family_schoolchild_and_students: {
        type: 'child',
        defaultAmount: 0,
        maxAmount: 42,
    },
};

const productsConfig = {
    productTypes,
    countryPassengerRules: {
        'Any-Any': ['adult', 'children', 'bike_slot'],
        'DK-DK': [
            'adult',
            'student',
            'children_0_11',
            'children_12_15',
            'pensioner',
            'bike_slot',
        ],
        'CL-CL': ['adult', 'cl_children_0_13', 'cl_children_14_17'],
        'CZ-CZ': [
            'adult',
            'student',
            'children_0_5',
            'children_6_17',
            'bike_slot',
            'pwd',
            'senior',
            'cz_disability_level_3',
        ],
        'CH-CH': ['adult'],
        'RU-RU': ['adult', 'children_0_12', 'children_13_14', 'bike_slot'],
        'TR-TR': [
            'adult',
            'children_6_11',
            'children_12_17',
            'tr_pwd',
            'bike_slot',
        ],
        'BR-BR': ['adult', 'br_children_0_15', 'br_child_on_lap'],
        'US-US': ['adult', 'us_children_2_15', 'bike_slot', 'wheelchair'],
        'CA-CA': ['adult', 'us_children_2_15', 'bike_slot', 'wheelchair'],
        'US-MX': ['adult', 'us_children_2_15', 'bike_slot', 'wheelchair'],
        'US-CA': ['adult', 'us_children_2_15', 'bike_slot', 'wheelchair'],
        'CA-US': ['adult', 'us_children_2_15', 'bike_slot', 'wheelchair'],
        'MX-US': ['adult', 'us_children_2_15', 'bike_slot', 'wheelchair'],
        'CA-MX': ['adult', 'us_children_2_15', 'wheelchair'],
        'MX-CA': ['adult', 'us_children_2_15', 'wheelchair'],
        'MX-MX': ['adult', 'mx_children_0_17'],
        'SE-SE': [
            'adult',
            'student',
            'se_children_0_15',
            'se_young_16_25',
            'senior',
            'bike_slot',
        ],
        'IN-IN': ['adult', 'in_children_0_17'],
        'GB-GB': ['adult', 'children', 'bike_slot', 'wheelchair'],
        'GB_SCT-GB_SCT': [
            'adult',
            'sct_nec_60_disabled',
            'sct_nec_16_21',
            'sct_nec_5_15',
            'children',
            'bike_slot',
        ],
        'EE-EE': [
            'adult',
            'children',
            'bike_slot',
            'ee_scholar_student',
            'ee_elderly',
            'ee_person_with_disability',
        ],
        'LV-LV': [
            'adult',
            'lv_person_with_disability_and_carer',
            'lv_child_0_7',
            'lv_child_8_14',
            'lv_orphaned_child',
            'lv_politically_repressed_person',
            'lv_large_family_adult',
            'lv_large_family_schoolchild_and_students',
            'bike_slot',
        ],
        // Fix this when proper PE child created
        'PE-PE': ['adult', 'mx_children_0_17'],
        'AU-AU': ['adult', 'children', 'wheelchair'],
    },
    countryPassengerRulesExtended: {
        'PL-PL': [
            'pl_blind_person_guide',
            'pl_blind_person',
            'pl_blind_war_victim',
            'pl_blind_dependent',
            'pl_war_invalid_carer',
            'pl_war_invalid_dependent',
            'pl_dependent_carer',
            'pl_dependent',
            'pl_border_guard',
            'pl_customs_officer',
            'pl_police_officer',
            'pl_military_police',
            'pl_child_disabled',
            'pl_child_disabled_carer',
            'pl_soldier',
            'pl_student_disabled',
            'pl_combatant',
            'pl_veteran_invalid',
            'pl_war_invalid',
            'pl_anti_communist_opposition_activist',
            'pl_child_0_4',
            'pl_child_5_6',
        ],
        'BR-BR': [
            'br_pwd_free',
            'br_ewli_free',
            'br_ewli_half',
            'br_ywli_free',
            'br_ywli_half',
            'br_children_0_5_free',
            'br_children_0_5_full',
        ],
        'US-US': ['us_veteran'],
        'MX-MX': ['student', 'mx_teacher', 'senior'],
    },
};

const getPassengerCount = (products) => {
    return Object.keys(products).reduce((count, type) => {
        if (!productsConfig.productTypes[type].withoutCapacity) {
            count += products[type] || 0;
        }
        return count;
    }, 0);
};

const getIsGlobalTripSearch = ({ departureCountryCode, arrivalCountryCode, locale, currency, }) => {
    if (!departureCountryCode || !arrivalCountryCode) {
        return false;
    }
    const indianDomain = departureCountryCode !== 'IN' &&
        arrivalCountryCode !== 'IN' &&
        locale === 'en_IN';
    const mexicanDomain = (!['MX', 'US'].includes(departureCountryCode) ||
        !['MX', 'US'].includes(arrivalCountryCode)) &&
        (locale === 'es_MX' || currency === 'MXN');
    const isPeruvianDomain = departureCountryCode !== 'PE' &&
        arrivalCountryCode !== 'PE' &&
        (locale === 'es_PE' || currency === 'PEN');
    return indianDomain || mexicanDomain || isPeruvianDomain;
};
const getExtendedProductsRules = (countryCodes, userType) => {
    const { departureCountry, arrivalCountry } = countryCodes;
    if (!departureCountry || !arrivalCountry)
        return null;
    const currentKey = `${departureCountry}-${arrivalCountry}`;
    return (extendedProductRules[currentKey] &&
        extendedProductRules[currentKey][userType]);
};

const DEFAULT_BRAND_UUID = 'a18f138c-68fa-4b45-a42f-adb0378e10d3';
const KAMIL_KOC_BRAND_UUID = 'ae1a154e-3da8-4031-ac12-d1fa41730eae';
const GREYHOUND_BRAND_UUID = '5f59428d-c840-44be-bd9e-2e1175e06779';
const FLIXTRAIN_BRAND_UUID = 'adf3cadd-7991-436c-be53-eb0f9c5ac165';
const CORE_BRAND_TYPE = 'core';
const PARTNER_BRAND_TYPE = 'partner';

const countries = [
    'AD',
    'AT',
    'AU',
    'BA',
    'BE',
    'BG',
    'BR',
    'CA',
    'CH',
    'CL',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GB',
    'GR',
    'HU',
    'HR',
    'IE',
    'IN',
    'IS',
    'IT',
    'LI',
    'LT',
    'LU',
    'LV',
    'MC',
    'ME',
    'MK',
    'MT',
    'MX',
    'NL',
    'NO',
    'PE',
    'PL',
    'PT',
    'RO',
    'RS',
    'RU',
    'SE',
    'SI',
    'SK',
    'SM',
    'TR',
    'UA',
    'US',
];

const replacePlaceholders = (string, parameters = {}) => {
    let mainStringParts = [string];
    Object.keys(parameters).forEach((key) => {
        const value = parameters[key];
        const tempStringParts = [];
        // use slice here instead of using the array directly, because
        // we shouldnt loop through the main array as it will be modified
        mainStringParts.slice(0).forEach((stringPart) => {
            if (typeof stringPart !== 'string') {
                tempStringParts.push(stringPart);
                return;
            }
            const segmentParts = stringPart.split(`%${key}%`);
            segmentParts.forEach((segmentPart, index) => {
                if (index > 0 && value !== undefined) {
                    tempStringParts.push(value.toString());
                }
                tempStringParts.push(segmentPart);
            });
        });
        mainStringParts = tempStringParts;
    });
    return mainStringParts.join('');
};

const chooseCountableTranslation = (variants, count) => {
    const variant = variants.find((variant) => {
        const { min, max } = variant;
        return count >= min && count <= max;
    });
    return replacePlaceholders((variant === null || variant === void 0 ? void 0 : variant.value) || '', { count });
};

const GREYHOUND_TRANSLATION_BRAND = 'greyhound';
const getTranslationBrand = (brand) => {
    if (brand === GREYHOUND_BRAND_UUID) {
        return GREYHOUND_TRANSLATION_BRAND;
    }
    return brand;
};

const noTranslationFoundFunction = () => '';
const getFromArray = (translationKeys, strings) => {
    return translationKeys.reduce((acc, currKey) => {
        if (!(currKey in strings)) {
            acc[currKey] = noTranslationFoundFunction;
            return acc;
        }
        acc[currKey] = (parameters) => replacePlaceholders(strings[currKey], parameters);
        return acc;
    }, {});
};
function getTranslationGetterFunction(strings, translationKey, brand) {
    if (translationKey instanceof Array) {
        return getFromArray(translationKey, strings);
    }
    if (!(translationKey in strings)) {
        return noTranslationFoundFunction;
    }
    const brandValue = strings[`${translationKey}@${brand}`];
    const value = brandValue || strings[translationKey];
    // The value is not a string, but it should be.
    if (typeof value === 'string') {
        return (parameters) => replacePlaceholders(value, parameters);
    }
    // It should be an array
    if (!('map' in value)) {
        return noTranslationFoundFunction;
    }
    return (parameters, count) => replacePlaceholders(chooseCountableTranslation(value.map((variant) => {
        return Object.assign(Object.assign({}, variant), { min: variant.min === 'Infinity' ? Infinity : variant.min, max: variant.max === 'Infinity' ? Infinity : variant.max });
    }), count), parameters);
}
const getTranslationProps = (strings, props, getAllTranslations, keysOrFunction, brand) => {
    const translationProps = {};
    let keys;
    const translationBrand = getTranslationBrand(brand);
    if (getAllTranslations) {
        translationProps['getTranslation'] = (id, ...rest) => getTranslationGetterFunction(strings, id, translationBrand)(...rest);
    }
    // First call keys because it's a function
    // that depends on the passed props.
    if (typeof keysOrFunction === 'function') {
        keys = keysOrFunction(props);
    }
    else {
        keys = keysOrFunction;
    }
    Object.keys(keys).forEach((propName) => {
        translationProps[propName] = getTranslationGetterFunction(strings, keys[propName], translationBrand);
    });
    return translationProps;
};

export { CORE_BRAND_TYPE, DEFAULT_BRAND_UUID, FLIXTRAIN_BRAND_UUID, GREYHOUND_BRAND_UUID, KAMIL_KOC_BRAND_UUID, PARTNER_BRAND_TYPE, SEAT_TYPES, SEAT_TYPES_PRICING_ORDER, countries, extendedProductRules, getExtendedProductsRules, getIsGlobalTripSearch, getPassengerCount, getTranslationGetterFunction, getTranslationProps, productsConfig };
